import { render, staticRenderFns } from "./SublimeSearch.vue?vue&type=template&id=36ffa81f&scoped=true&"
import script from "./SublimeSearch.vue?vue&type=script&lang=ts&"
export * from "./SublimeSearch.vue?vue&type=script&lang=ts&"
import style0 from "./SublimeSearch.vue?vue&type=style&index=0&id=36ffa81f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ffa81f",
  null
  
)

export default component.exports